import { SkeletonCard } from './SkeletonCard';

export const LoadingState = ({ times }: { times: number }) => (
  <div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-4">
    {Array.from({ length: times }, (_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);
